import type { IconData } from '@stacksjs/iconify-core'

export const checkThickSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M20.636 21.226q.459.528.822.954c.56-.81 1.32-1.907 2.264-3.26a1452 1452 0 0 1 9.182-13.009c1.515-2.123 4.44-3.364 7.08-1.899c1.571.872 3.445 2.223 4.921 4.235c1.464 1.995 1.033 4.504-.108 6.232c-8.563 12.973-14.743 20.874-18.184 24.986c-2.25 2.69-6.181 2.876-8.707.48A167 167 0 0 1 3.793 24.743c-1.548-1.896-2.006-4.773-.303-6.956c1.105-1.415 2.354-2.615 3.465-3.553c2.455-2.073 5.885-1.514 7.918.64a209 209 0 0 1 5.763 6.353\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default checkThickSolid
